import WorkoutHistoryTabs from './WorkoutHistoryTabs';

export default WorkoutHistoryTabs;
